import React, { memo, useState } from 'react';
import classnames from 'classnames';
import { IconLoader } from 'common/IconLoader';
import ProvisionModal from 'components/features/ProvisionModal/ProvisionModal';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { GA2_TAB_SCENARIOS } from '../utils';

const BundleOverviewControllerGa2ErrorTab = ({ id, device, donorDevice, deviceType, errorType, activeIndex }) => {
  const [isProvisionModalOpen, setIsProvisionModalOpen] = useState(false);
  const rfPath = device?.type?.slice(2);

  const errorMessage =
    errorType === GA2_TAB_SCENARIOS.ID_NOT_MATCHED
      ? 'The serial number does not match.'
      : errorType === GA2_TAB_SCENARIOS.TYPE_NOT_MATCHED
      ? 'The ne-type does not match.'
      : '';

  return (
    <div
      id={`BundleOverviewControllerTab_${deviceType}_${id}`}
      key={id}
      className={classnames('BundleOverviewControllerTab', {
        BundleOverviewControllerTabFocus: activeIndex === device?.deviceId,
        BundleOverviewControllerGa2ErrorTab: true
      })}
    >
      {isProvisionModalOpen && (
        <ProvisionModal targetDevice={donorDevice} onClose={() => setIsProvisionModalOpen(false)} />
      )}
      <div className="BundleOverviewControllerTabDeviceLabel">
        <SvgAF img={IconLoader.icon_service} />
        <div className="BundleOverviewControllerTabDeviceLabelId" data-tip={device?.deviceId}>
          {device?.deviceId || device?.id}
        </div>
      </div>

      <div className="BundleOverviewControllerTabRfPathContainer">
        <div className="BundleOverviewControllerTabRfPathHeader">Sector</div>
        <div className="BundleOverviewControllerTabRfPathValue">{rfPath}</div>
      </div>

      <div
        className={classnames('BundleOverviewControllerTabBottomContainer', {
          BundleOverviewControllerGa2ErrorTabBottomerContainer: true
        })}
      >
        <div>{errorMessage}</div>
        <button
          className={classnames('BundleOverviewControllerTabBottomContainer_ReviewBtn')}
          onClick={() => {
            setIsProvisionModalOpen(true);
          }}
        >
          Review Sector
        </button>
      </div>
    </div>
  );
};

export default memo(BundleOverviewControllerGa2ErrorTab);
